export const inviteMembers = {
  title: '成员邀请',
  team: '团队',
  project: '项目',
  addTeam: '加入团队',
  addItem: '加入项目',
  slogan1: '加入项目后可以共享设计方案，高效沟通交流',
  slogan2: '加入后可以资源共享，高效沟通交流',
  inviteMsg: 'Hi，{invUserName}邀请您加入',
  submit: '加入',
  result: 'Hi，您已加入',
  info: '「{result}」的团队',
  info2: '「{result}」',
  hitMessage1: '关注',
  hitMessage2: '【福昕家装云服务】',
  hitMessage3: '公众号，点击底部菜单',
  hitMessage4: '「云服务-尊享版」',
  hitMessage5: '，即可查看项目内容～',
  hitMessage6: '长按上方二维码识别关注',
}
